/* Подсчет штиля */
export default function CalculateСalmProcent(data) {
    const procent = []
    data.forEach(item => {
        const length = item.length
        let countCalm = 0
        item.forEach(speed => {
            if (speed < 0.5) {
                countCalm++
            }
        })
        const result = countCalm / length * 100
        procent.push(result)
    })
    return procent
}
